export const packageVersion = process.env.PKG_VERSION || '0.0.0-development';
export const packageName =
  process.env.PKG_NAME || '@stream-io/audio-filters-web';
